import { isDarkTheme } from "webapp/lib/theme/theme";
import { styled } from "../../../styled-components";

export const TextFieldViewStyle = styled.div<{ isEnabled: boolean }>`
    --padding: 12px;

    .input-wrap {
        padding: var(--padding);

        background-color: ${p => p.theme.picker.backgroundColor};
        border-radius: ${p => p.theme.preferredRoundingRadius}px;

        color: ${p => p.theme.fgColorDark};
        transition: background-color 150ms ease-in-out, box-shadow 150ms ease-in-out;

        ${p => p.theme.fontStyles.Body4}

        display: flex;

        .prefix {
            align-self: center;
            color: ${p => p.theme.fgColorLight};
            padding-right: 4px;
        }

        .suffix {
            align-self: center;
            color: ${p => p.theme.fgColorLight};
            padding-left: 4px;
        }
    }

    .input {
        width: 100%;
        --base-height: calc(44px - 2 * var(--padding));
        min-height: var(--base-height);
        &.medium {
            min-height: calc(4 * var(--base-height));
        }
        &.large {
            min-height: calc(10 * var(--base-height));
        }
        color: ${p => p.theme.fgColorDark};

        ::-webkit-calendar-picker-indicator {
            opacity: 0.4;
            filter: ${p => (isDarkTheme(p.theme) ? "invert(1)" : "invert(0)")};
        }

        ::placeholder {
            color: ${p => p.theme.fgColorLight};
        }
    }

    &.focused {
        .input-wrap {
            box-shadow: 0 0 0 2px ${p => p.theme.primaryAccentColor};
        }
        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
            .input-wrap {
                box-shadow: 0 0 0 1.5px ${p => p.theme.primaryAccentColor};
            }
        }
    }

    @media (hover: hover) {
        &:hover {
            .input-wrap {
                background-color: ${p => p.theme.picker.hoverBgColor};
            }
        }
    }

    &.error {
        .input-wrap {
            box-shadow: 0 0 0 2px ${p => p.theme.destroyColor};
        }
        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
            .input-wrap {
                box-shadow: 0 0 0 1.5px ${p => p.theme.destroyColor};
            }
        }
    }
`;
